export const PORT_CURRENT_FLOW_ZOOM = 11;
export const PORT_CURRENT_FLOW_PARTICLE_DENSITY = "medium";

const validCoordinate = (point) => point
  && Number.isFinite(point.latitude) && point.latitude >= -90 && point.latitude <= 90
  && Number.isFinite(point.longitude) && point.longitude >= -180 && point.longitude <= 180;

export function portCurrentFlowView(portLocation, samplingLocation) {
  const focus = validCoordinate(samplingLocation) ? samplingLocation
    : validCoordinate(portLocation) ? portLocation : null;
  return focus ? { center: [focus.latitude, focus.longitude], zoom: PORT_CURRENT_FLOW_ZOOM } : null;
}

export function portCurrentFlowMapUrl(portLocation, samplingLocation, origin, zoomOffset = 0) {
  const view = portCurrentFlowView(portLocation, samplingLocation);
  if (!view) return null;
  const offset = Number.isFinite(zoomOffset) ? zoomOffset : 0;
  const url = new URL("/map", origin);
  url.hash = `map=${Math.max(0, view.zoom + offset)}/${view.center[0].toFixed(4)}/${view.center[1].toFixed(4)}&layer=currents`;
  return url.href;
}

